import styles from "./postDetailshero.module.scss";
import DateFormater from "../blogComponents/date-formater";
import { Image } from "@chakra-ui/react";
import { useState, useEffect } from "react";

import {
	FacebookShareButton,
	LinkedinShareButton,
	TwitterShareButton,
	InstapaperShareButton,
} from "react-share";

const PostDetailsHero = ({ title, coverImage, date, author, post }) => {
	let modifiedSrc = process.env.base_path + coverImage;

	const [copied, setCopied] = useState(false);
	function copyUrl() {
		const el = document.createElement("input");
		el.value = window.location.href;
		document.body.appendChild(el);
		el.select();
		document.execCommand("copy");
		setCopied(true);
		document.body.removeChild(el);
	}
	return (
		<section className={styles.main}>
			<div className={styles.main__left}>
				<div className={styles.main__left__content}>
					<b>Hair salons</b>
					<h1>{title}</h1>

					<div className={styles.author__icons__container}>
						<div className={styles.authorInfos}>
							<Image
								src={author.picture}
								width='40px'
								height='40px'
								className={styles.profilePic}
							/>
							<div className={styles.nameAndDate}>
								<p>
									By <span>{author.name} </span>
								</p>
								<p>
									<DateFormater dateString={date && date} />
								</p>
							</div>
						</div>

						<div className={styles.icon__container}>
							<div className={styles.socialsIcon}>
								<TwitterShareButton
									url={`https://coverclap.com/blog/${post.slug}`}
									quote={`${post.title}`}
								>
									<img src='/twitter.svg' alt='social icon' />
								</TwitterShareButton>
							</div>

							<div className={styles.socialsIcon}>
								<FacebookShareButton
									url={`https://coverclap.com/blog/${post.slug}`}
									quote={`${post.title}`}
								>
									<img src='/fb.svg' alt='social icon' />
								</FacebookShareButton>
							</div>

							{copied ? (
								<span>copied!</span>
							) : (
								<div onClick={() => copyUrl()} className={styles.socialsIcon}>
									<img src='/in.svg' alt='social icon' />
								</div>
							)}
						</div>
					</div>
				</div>

				<div className={styles.border__bottom} />
			</div>
			<picture className={styles.heroCover}>
				<img src={modifiedSrc} />

				{/* <Image
          fallbackSrc="https://via.placeholder.com/350"
          height={"100%"}
          objectFit="cover"
          src={modifiedSrc}
          alt="Hero Image"
        /> */}
			</picture>
		</section>
	);
};

export default PostDetailsHero;
